<template>
    <v-card class="rounded-0">
        <v-toolbar class="no-printable" color="primary" dark>
            
            <v-btn @click="cancelPrint" icon>
                <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Impression Fiche d'Opérations</v-toolbar-title>
            <v-select
            width="100px"
            class="ml-5"
            :items="['Prime', 'Unibox']"
            v-model="societe"
            hide-details
            dense
            ></v-select>
            <v-spacer></v-spacer>
            
            <v-btn @click="PrintOperations" text>
                Confirmer
                <v-icon>mdi-check</v-icon>
            </v-btn>

        </v-toolbar>
        <div class="fullwidth" v-if="societe === 'Prime'">
            <div class="width-50">
                <div class="printable-content">
                    <img class="logo" src="https://i.imgur.com/J8CnA93.png" />
                </div>
            </div>
            <div class="width-50">
                <div class="printable-content">
                    <div class="info-text">
                        <b>Prime Shipping Agency </b><br/>
                        3 Rue Habib Thameur 1er Etage App N°2 Rades 2040 <br/>
                        Ben Arous Tunisie. Tél. : +216 71 461 710 <br/>
                        Email : manager@primeshipping.tn <br/>
                    </div>
                </div>
            </div>
        </div>
        <div class="fullwidth" v-if="societe === 'Unibox'">
            <div class="width-50">
                <div class="printable-content">
                    <img class="logo" src="https://i.imgur.com/LBw0phu.jpg" />
                </div>
            </div>
            <div class="width-50">
                <div class="printable-content">
                    <div class="info-text">
                        <b>Unibox Express Delivery</b><br/>
                        Rue de l'exportation Zone Industrielle rades 2040 <br/>
                        Ben Arous Tunisie. Tél. : +216 71 461 699  <br/>
                        Email : safa.masri@unibox.tn <br/>
                    </div>
                </div>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="fullwidth">
            <div class="printable-content  p-b-0">
                <h3>Opérations relatives à {{currentClientData.fullname}} Ref#{{currentClientData.code_client}} </h3>
                <h5> <span v-if="period_ops.period !== 'Toujours'">{{period_ops.period}} | </span> Du <span v-if="period_ops.from !== null">{{period_ops.from | formatDate}}</span><span v-else>-</span> à  {{period_ops.to  | formatDate}}</h5>
            </div>
        </div>
        <div class="clearfix"></div>
        <div class="fullwidth">
            <div class="printable-content p-t-0 p-b-0">
                <div class="data-dossier">
                    <div class="single-data width-33"><b>Nom:</b> {{currentClientData.fullname}}</div>
                    <div class="single-data width-33"><b>Code Client:</b> {{currentClientData.code_client}} </div>
                    <div class="clearfix"></div>
                    <div class="single-data width-33"><b>Matricule Fiscale:</b> {{currentClientData.mf}}</div>
                    <div class="single-data width-33"><b>Adresse:</b> {{currentClientData.adresse}} -  {{currentClientData.code_postal}} {{currentClientData.region}} </div>
                    <div class="single-data width-33"><b>Téléphone:</b> {{currentClientData.tel}}</div>
                    <div class="clearfix"></div>
                </div>
            </div>
        </div>
        <div class="fullwidth">
            <div class="printable-content">
                <div class="fullwidth">
                    <table border=0 class="table-print" width="100%">
                        <tr>
                            <td>Date</td>
                            <td>Dossier/Avis relatifs</td>
                            <td>N°Facture</td>
                            <td>Libelle</td>
                            
                            <td class="right">Débit</td>
                            <td class="right">Crédit</td>
                        </tr>
                        <tr v-for="op in operations" v-bind:key="op.id">
                            <td>{{op.date | formatDate}}</td>
                            <td>
                                <template v-if="op.avis_id > 0">
                                Dossier {{ avisList.filter(obj => {
                                    return obj.id === op.avis_id
                                })[0].dossier.num_dossier }} - Avis {{ avisList.filter(obj => {
                                    return obj.id === op.avis_id
                                })[0].num_avis }}
                                </template>
                                <template v-else-if="op.dossier_id > 0">
                                    Dossier N°{{dossierList.filter(obj => {
                                    return obj.id === op.dossier_id
                                    })[0].numdossier }}
                                </template>
                                <template v-else>
                                    -
                                </template>
                            </td>
                            <td>{{op.num_facture}}</td>
                            <td>{{op.libelle}}</td>
                            
                            <td class="right">{{op.debit.toFixed(3)}}</td>
                            <td class="right">{{op.credit.toFixed(3)}}</td>
                        </tr>
                        <tr>
                            <td colspan="4" class="right total">
                                Total
                            </td>
                            
                            <td class="right total">{{debit.toFixed(3)}}</td>
                            <td class="right total">{{credit.toFixed(3)}}</td>
                        </tr>
                        <tr>
                            <td colspan="4" class="right total">
                                Solde
                            </td>
                            
                            <td colspan="2" class="right total">{{Number(debit - credit).toFixed(3)}}</td>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </v-card>
</template>
<script>
import Printd from 'printd'

export default {
    name: 'print-ops',
    props: ['operations', 'currentClientData', 'period_ops', 'avisList', 'dossierList'],
    data: () => ({
        d: null,
        societe: 'Prime',
        cssText: `
            @import url('https://fonts.googleapis.com/css2?family=Montserrat&display=swap');
            .total p{
                font-size:10px;
                padding: 2px;
            }
            .p-b-0{
                padding-bottom:0px !important;
            }
            .p-t-0{
                padding-top: 0px !important;
            }
            .total{
                padding: 10px;
                border: 1px solid rgba(0,0,0,0.2);
                font-weight:700;
                font-size:12px;
                margin-left: 20px;
                margin-bottom:10px;
            }
            *{
                margin:0;
                font-family: "Montserrat",sans-serif;
                outline: none;
            }
            .right {
                text-align:right;
            }
            .no-printable {
                display:none;
            }
            .fullwidth{
                width:100%;
            }
            .width-50{
                width:50% !important;
                float:left;
            }
            .width-75{
                width:75% !important;
                float:left;
            }
            .width-25{
                width:25% !important;
                float:left;
            }
            .width-33{
                width:33% !important;
                float:left;
            }
            .printable-content{
                margin: 8px;
                padding:15px;
            }
            .logo {
                width:150px;
            }
            .info-text {
                font-size:14px !important;
                line-height:20px;
                font-weight:400 !important;
                letter-spacing:1.2px;
                color: #000;
            }
            .clearfix{
                clear:both;
            }
            .client-label{
                font-size:12px;
            }
            .coordonnee-client{
                border: 2px solid rgba(0,0,0,0.2);
                padding:15px;
            }
            .coordonnee-bancaire{
                border: 2px solid rgba(0,0,0,0.2);
                padding:15px;
            }
            .text-line{
                font-size:14px;
                font-weight:normal;
            }
            .table-print{
                border-collapse: collapse;
            }
            .table-print td{
                padding:2px 4px;
                font-size:11px;
            }
            .table-print td{
                border: 1px solid rgba(0,0,0,0.2);
            }
            .footer-data{
                font-size:10px;
                line-height:18px;
                letter-spacing:1.2px;
            }
            .data-dossier .single-data{
                width:25%;
                float:left;
                font-size:9px;
                margin-top:3px;
                height: 10px;
            }
            .info-bar{
                font-size: 12px;
            }
            .no-border{
                border: 0px solid !important;
            }
            @media print{@page {size: landscape; width:100%;}}
            `,
        credit: 0,
        debit: 0,
        solde: 0,
    }),
    mounted() {
        this.credit = 0
        this.debit = 0
        this.operations.forEach((item, key) => {
            this.credit = this.credit + item.credit
            this.debit = this.debit + item.debit
        })
        this.solde = this.debit - this.credit
    },
    methods: {
        cancelPrint(){
            this.$emit("hide", true)
        },
        PrintOperations(){
            this.d = new Printd()
            this.d.print( this.$el, [this.cssText])
        }
    }
}
</script>
<style scoped>
@media print{@page {size: landscape; width:100%;}}
.total{
    font-weight:700;
}
div {
    text-align:left;
}
.logo {
    width:150px;
}
.printable-content{
    margin: 8px;
    padding:15px;
}
.fullwidth{
    width:100%;
}
.right {
    text-align:right;
}
.fullwidth{
    width:100%;
}
.width-50{
    width:50% !important;
    float:left;
}
.width-75{
    width:75% !important;
    float:left;
}
.width-25{
    width:25% !important;
    float:left;
}
.width-33{
    width:33% !important;
    float:left;
}
.info-text {
    font-size:14px !important;
    line-height:20px;
    font-weight:400 !important;
    letter-spacing:1.2px;
    color: #000;
}
.clearfix{
    clear:both;
}
.p-b-0{
    padding-bottom:0px !important;
}
.client-label{
    font-size:12px;
}
.coordonnee-client{
    border: 2px solid rgba(0,0,0,0.2);
    padding:15px;
    margin: 5px;
}
.coordonnee-bancaire{
    border: 2px solid rgba(0,0,0,0.2);
    padding:15px;
}
.text-line{
    font-size:14px;
    font-weight:normal;
}
.table-print{
    border-collapse: collapse;
}
.table-print td{
    padding:5px 7px;
}
.table-print td{
    border: 1px solid rgba(0,0,0,0.2);
}
.footer-data{
    font-size:13px;
    line-height:20px;
    letter-spacing:1.5px;
}
.data-dossier .single-data{
    width:25%;
    float:left;
}
.no-border{
    border: 0px solid !important;
}
</style>


// WEBPACK FOOTER //
// src/views/dashboard/customer/print.vue